"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertEnumValue = exports.isEnumValue = exports.assertEnumKey = exports.isEnumKey = exports.assertEnumKeyFromValue = exports.getEnumKeyFromValue = exports.getEnumValues = exports.getEnumKeys = void 0;
function getEnumKeys(enumerable) {
    const keys = [];
    for (const key of Object.keys(enumerable)) {
        if (Number.isNaN(Number.parseInt(key))) {
            keys.push(key);
        }
    }
    return keys;
}
exports.getEnumKeys = getEnumKeys;
function getEnumValues(enumerable) {
    return getEnumKeys(enumerable).map((key) => enumerable[key]);
}
exports.getEnumValues = getEnumValues;
function getEnumKeyFromValue(enumerable, value) {
    if (typeof value === 'number') {
        // For numeric enums
        return enumerable[value];
    }
    else {
        // For string enums
        for (const [k, v] of Object.entries(enumerable)) {
            if (value === v) {
                return k;
            }
        }
    }
    return undefined;
}
exports.getEnumKeyFromValue = getEnumKeyFromValue;
function assertEnumKeyFromValue(enumerable, value) {
    const key = getEnumKeyFromValue(enumerable, value);
    if (!key) {
        throw new Error(`The value "${value}" does not belong to this enum, choose among: ${getEnumValues(enumerable).join(', ')}`);
    }
    return key;
}
exports.assertEnumKeyFromValue = assertEnumKeyFromValue;
function isEnumKey(enumerable, key) {
    return getEnumKeys(enumerable).includes(key);
}
exports.isEnumKey = isEnumKey;
function assertEnumKey(enumerable, key) {
    if (!isEnumKey(enumerable, key)) {
        throw new Error(`The key "${key}" does not belong to this enum, choose among: ${getEnumKeys(enumerable).join(', ')}`);
    }
    return key;
}
exports.assertEnumKey = assertEnumKey;
function isEnumValue(enumerable, value) {
    return getEnumValues(enumerable).includes(value);
}
exports.isEnumValue = isEnumValue;
function assertEnumValue(enumerable, value) {
    if (!isEnumValue(enumerable, value)) {
        throw new Error(`The value "${value}" does not belong to this enum, choose among: ${getEnumValues(enumerable).join(', ')}`);
    }
    return value;
}
exports.assertEnumValue = assertEnumValue;
//# sourceMappingURL=enum.js.map